export const SINGLE_SURFACES = ["B", "F", "V", "M", "O", "I", "D", "L"] as const;

export const COMMON_SURFACE_COMBINATIONS = [
  "MO",
  "DO",
  "MOD",
  "MI",
  "DI",
  "MID",
  "BO",
  "LO",
] as const;

export const QUADRANT_SURFACES = [
  { code: "UR", label: "Upper Right" },
  { code: "UL", label: "Upper Left" },
  { code: "LR", label: "Lower Right" },
  { code: "LL", label: "Lower Left" },
] as const;

export const SEXTANT_SURFACES = ["1", "2", "3", "4", "5", "6"] as const;

export const ARCH_SURFACES = [
  { code: "U", label: "Upper Arch" },
  { code: "L", label: "Lower Arch" },
] as const;
